"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var variables_1 = require("../variables");
var configuration_1 = require("../configuration");
var ApiService = (function () {
    function ApiService(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new http_1.HttpHeaders();
        this.configuration = new configuration_1.Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    ApiService.prototype.canConsumeForm = function (consumes) {
        var form = 'multipart/form-data';
        for (var _i = 0, consumes_1 = consumes; _i < consumes_1.length; _i++) {
            var consume = consumes_1[_i];
            if (form === consume) {
                return true;
            }
        }
        return false;
    };
    ApiService.prototype.apiCompaniesGet = function (observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/companies", {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiCompanyCompanyIdGet = function (companyId, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling apiCompanyCompanyIdGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/company/" + encodeURIComponent(String(companyId)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiDeviceCompanyIdDeviceIdDeviceTypeGet = function (companyId, deviceId, deviceType, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling apiDeviceCompanyIdDeviceIdDeviceTypeGet.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling apiDeviceCompanyIdDeviceIdDeviceTypeGet.');
        }
        if (deviceType === null || deviceType === undefined) {
            throw new Error('Required parameter deviceType was null or undefined when calling apiDeviceCompanyIdDeviceIdDeviceTypeGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/device/" + encodeURIComponent(String(companyId)) + "/" + encodeURIComponent(String(deviceId)) + "/" + encodeURIComponent(String(deviceType)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiDevicesCompanyIdDeviceTypeGet = function (companyId, deviceType, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling apiDevicesCompanyIdDeviceTypeGet.');
        }
        if (deviceType === null || deviceType === undefined) {
            throw new Error('Required parameter deviceType was null or undefined when calling apiDevicesCompanyIdDeviceTypeGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/devices/" + encodeURIComponent(String(companyId)) + "/" + encodeURIComponent(String(deviceType)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiDevicesDeviceTypeGet = function (deviceType, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (deviceType === null || deviceType === undefined) {
            throw new Error('Required parameter deviceType was null or undefined when calling apiDevicesDeviceTypeGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/devices/" + encodeURIComponent(String(deviceType)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiGatewayCommandSendPost = function (body, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', this.basePath + "/api/gateway/command/send", {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiGatewayCommandsGatewayIdLimitGet = function (gatewayId, limit, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (gatewayId === null || gatewayId === undefined) {
            throw new Error('Required parameter gatewayId was null or undefined when calling apiGatewayCommandsGatewayIdLimitGet.');
        }
        if (limit === null || limit === undefined) {
            throw new Error('Required parameter limit was null or undefined when calling apiGatewayCommandsGatewayIdLimitGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/gateway/commands/" + encodeURIComponent(String(gatewayId)) + "/" + encodeURIComponent(String(limit)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiGatewayGatewayIdGet = function (gatewayId, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (gatewayId === null || gatewayId === undefined) {
            throw new Error('Required parameter gatewayId was null or undefined when calling apiGatewayGatewayIdGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/gateway/" + encodeURIComponent(String(gatewayId)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiGatewayGatewayIdLocationGet = function (gatewayId, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (gatewayId === null || gatewayId === undefined) {
            throw new Error('Required parameter gatewayId was null or undefined when calling apiGatewayGatewayIdLocationGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/gateway/" + encodeURIComponent(String(gatewayId)) + "/location", {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiGatewayGatewayIdLocationPeriodDateTimeFromDateTimeToGet = function (gatewayId, dateTimeFrom, dateTimeTo, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (gatewayId === null || gatewayId === undefined) {
            throw new Error('Required parameter gatewayId was null or undefined when calling apiGatewayGatewayIdLocationPeriodDateTimeFromDateTimeToGet.');
        }
        if (dateTimeFrom === null || dateTimeFrom === undefined) {
            throw new Error('Required parameter dateTimeFrom was null or undefined when calling apiGatewayGatewayIdLocationPeriodDateTimeFromDateTimeToGet.');
        }
        if (dateTimeTo === null || dateTimeTo === undefined) {
            throw new Error('Required parameter dateTimeTo was null or undefined when calling apiGatewayGatewayIdLocationPeriodDateTimeFromDateTimeToGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/gateway/" + encodeURIComponent(String(gatewayId)) + "/location/period/" + encodeURIComponent(String(dateTimeFrom)) + "/" + encodeURIComponent(String(dateTimeTo)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiGatewayGatewayIdUpdateLocationPost = function (gatewayId, body, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (gatewayId === null || gatewayId === undefined) {
            throw new Error('Required parameter gatewayId was null or undefined when calling apiGatewayGatewayIdUpdateLocationPost.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', this.basePath + "/api/gateway/" + encodeURIComponent(String(gatewayId)) + "/update/location", {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiGatewaysCompanyIdGet = function (companyId, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling apiGatewaysCompanyIdGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/gateways/" + encodeURIComponent(String(companyId)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiGatewaysGet = function (observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/gateways", {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiTdDeviceCompanyIdDeviceIdGatewayIdLastHoursGet = function (companyId, deviceId, gatewayId, lastHours, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling apiTdDeviceCompanyIdDeviceIdGatewayIdLastHoursGet.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling apiTdDeviceCompanyIdDeviceIdGatewayIdLastHoursGet.');
        }
        if (gatewayId === null || gatewayId === undefined) {
            throw new Error('Required parameter gatewayId was null or undefined when calling apiTdDeviceCompanyIdDeviceIdGatewayIdLastHoursGet.');
        }
        if (lastHours === null || lastHours === undefined) {
            throw new Error('Required parameter lastHours was null or undefined when calling apiTdDeviceCompanyIdDeviceIdGatewayIdLastHoursGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/td/device/" + encodeURIComponent(String(companyId)) + "/" + encodeURIComponent(String(deviceId)) + "/" + encodeURIComponent(String(gatewayId)) + "/" + encodeURIComponent(String(lastHours)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiTdDeviceCompanyIdDeviceIdLastHoursGet = function (companyId, deviceId, lastHours, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling apiTdDeviceCompanyIdDeviceIdLastHoursGet.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling apiTdDeviceCompanyIdDeviceIdLastHoursGet.');
        }
        if (lastHours === null || lastHours === undefined) {
            throw new Error('Required parameter lastHours was null or undefined when calling apiTdDeviceCompanyIdDeviceIdLastHoursGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/td/device/" + encodeURIComponent(String(companyId)) + "/" + encodeURIComponent(String(deviceId)) + "/" + encodeURIComponent(String(lastHours)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiTdDeviceCompanyIdDeviceIdPeriodDateTimeFromDateTimeToGet = function (companyId, deviceId, dateTimeFrom, dateTimeTo, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling apiTdDeviceCompanyIdDeviceIdPeriodDateTimeFromDateTimeToGet.');
        }
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling apiTdDeviceCompanyIdDeviceIdPeriodDateTimeFromDateTimeToGet.');
        }
        if (dateTimeFrom === null || dateTimeFrom === undefined) {
            throw new Error('Required parameter dateTimeFrom was null or undefined when calling apiTdDeviceCompanyIdDeviceIdPeriodDateTimeFromDateTimeToGet.');
        }
        if (dateTimeTo === null || dateTimeTo === undefined) {
            throw new Error('Required parameter dateTimeTo was null or undefined when calling apiTdDeviceCompanyIdDeviceIdPeriodDateTimeFromDateTimeToGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/td/device/" + encodeURIComponent(String(companyId)) + "/" + encodeURIComponent(String(deviceId)) + "/period/" + encodeURIComponent(String(dateTimeFrom)) + "/" + encodeURIComponent(String(dateTimeTo)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiTdGatewayCompanyIdGatewayIdDeviceTypeLastHoursGet = function (companyId, gatewayId, deviceType, lastHours, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling apiTdGatewayCompanyIdGatewayIdDeviceTypeLastHoursGet.');
        }
        if (gatewayId === null || gatewayId === undefined) {
            throw new Error('Required parameter gatewayId was null or undefined when calling apiTdGatewayCompanyIdGatewayIdDeviceTypeLastHoursGet.');
        }
        if (deviceType === null || deviceType === undefined) {
            throw new Error('Required parameter deviceType was null or undefined when calling apiTdGatewayCompanyIdGatewayIdDeviceTypeLastHoursGet.');
        }
        if (lastHours === null || lastHours === undefined) {
            throw new Error('Required parameter lastHours was null or undefined when calling apiTdGatewayCompanyIdGatewayIdDeviceTypeLastHoursGet.');
        }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/td/gateway/" + encodeURIComponent(String(companyId)) + "/" + encodeURIComponent(String(gatewayId)) + "/" + encodeURIComponent(String(deviceType)) + "/" + encodeURIComponent(String(lastHours)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiUserAccessKeyGet = function (observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/userAccessKey", {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiUserAccessKeyPost = function (observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('post', this.basePath + "/api/userAccessKey", {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService.prototype.apiUserGet = function (observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        var headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-KEY"]) {
            headers = headers.set('X-API-KEY', this.configuration.apiKeys["X-API-KEY"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["X-API-SECRET"]) {
            headers = headers.set('X-API-SECRET', this.configuration.apiKeys["X-API-SECRET"]);
        }
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }
        var httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        var consumes = [];
        return this.httpClient.request('get', this.basePath + "/api/user", {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    ApiService = __decorate([
        core_1.Injectable(),
        __param(1, core_1.Optional()), __param(1, core_1.Inject(variables_1.BASE_PATH)), __param(2, core_1.Optional()),
        __metadata("design:paramtypes", [http_1.HttpClient, String, configuration_1.Configuration])
    ], ApiService);
    return ApiService;
}());
exports.ApiService = ApiService;
//# sourceMappingURL=api.service.js.map